<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Офферы Leadsu {{ leadsu_offers ? `(${leadsu_offers.total})` : '' }}</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <v-text-field
          outlined
          dense
          hide-details
          clearable
          label="Название"
          v-model="params.search"
          @click:clear="onClear"
          @keyup.enter="getLeadsuOffers"
        />
      </div>
      <div class="column is-narrow">
        <b-button class="edit_icon" @click="getLeadsuOffers">
          <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' width="20" height="20">
            <path stroke='#6A7282' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M21 21l-4.35-4.35M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0z'/>
          </svg>
        </b-button>
      </div>
      <div class="column is-narrow">
        <b-button class="edit_icon" @click="goToLeadsuList">
          <svg aria-hidden='true' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
            <path stroke='#6A7282' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z'/>
            <path stroke='#6A7282' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'/>
          </svg>
        </b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="leadsu_offers.results"
      class="users-table"

      paginated
      backend-pagination
      :total="leadsu_offers.total"
      :per-page="params.perPage"
      @page-change="onPageChange"

      detailed
      detail-key="id"
      :opened-detailed="openedOffersList"
    >
      <b-table-column label="ID" v-slot="props">
        <span>{{ props.row.id }}</span>
      </b-table-column>

      <b-table-column label="Лого" v-slot="props">
        <div class="image" style="width: 150px;">
          <img :src="props.row.logo" />
        </div>
      </b-table-column>

      <b-table-column label="Имя" v-slot="props">
        <span>{{ props.row.name }}</span>
      </b-table-column>

      <b-table-column label="Страна" v-slot="props">
        <span>{{ props.row.countries ? props.row.countries[0] : '' }}</span>
      </b-table-column>

      <b-table-column label="Действия" v-slot="props">

        <div  class="is-flex is-align-items-center fill-height">
          <b-button type="is-primary" @click="getDataForOffer(props.row.id)" class="mr-5">Смотреть</b-button>

          <b-tooltip label="Перейти в leadsu">
            <b-button class="edit_icon" @click="redirectToLeadsu(props.row.id)">
              <svg xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 64 64;" viewBox="0 0 64 64" xml:space="preserve">
                    <g>
                      <g transform="translate(382.000000, 380.000000)">
                        <!-- fill="#6d757d" -->
                        <polyline points="-352.3,-343.4 -354.6,-345.7 -328.8,-371.4 -326.6,-369.2 -352.3,-343.4    "/>
                        <polyline points="-326,-354.9 -329.4,-354.9 -329.4,-368.6 -343.1,-368.6 -343.1,-372 -326,-372      -326,-354.9    "/>
                        <path d="M-334.6-324h-34.3c-2.8,0-5.1-2.3-5.1-5.1v-34.3c0-2.8,2.3-5.1,5.1-5.1h18.9v3.4h-18.9     c-0.9,0-1.7,0.8-1.7,1.7v34.3c0,0.9,0.8,1.7,1.7,1.7h34.3c0.9,0,1.7-0.8,1.7-1.7V-348h3.4v18.9C-329.4-326.3-331.7-324-334.6-324     " />
                      </g>
                    </g>
                  </svg>
            </b-button>
          </b-tooltip>
        </div>

      </b-table-column>

      <template slot="detail" slot-scope="props">
        <div style="width: 100%; overflow-x: auto;" :style="{ maxWidth: maxDetailWidth + 'px' }">
          <b-table
            ref="innerTable"
            :data="getOfferGoals(props.row.id)?.goals || []">

            <b-table-column label="Цель" v-slot="g">
              {{ g.row.goal_name }}
            </b-table-column>

            <!-- Колонка для дефолтных значений (ключ "0") -->
            <b-table-column label="default">
              <template #header>
                <b-tooltip label='Значения "для всех"' append-to-body dashed>
                  default
                </b-tooltip>
              </template>

              <template v-slot="g">
                {{
                  g.row.payouts['0']?.amount !== undefined
                    ? g.row.payouts['0']?.amount + ' ' + g.row.payouts['0']?.currency
                    : '-'
                }}
              </template>
            </b-table-column>

            <!-- Колонки для каждого аккаунта -->
            <b-table-column
              v-for="acc in leadsu_accounts"
              :key="acc.id"
            >
              <template #header>
                <b-tooltip :label="acc.name" append-to-body dashed>
                  {{ acc.leadsu_id }}{{ acc.is_favorite ? '⭐' : '' }}
                </b-tooltip>
              </template>

              <template v-slot="g">
                {{
                  g.row.payouts[acc.id]?.amount !== undefined
                    ? g.row.payouts[acc.id]?.amount + ' ' + g.row.payouts[acc.id]?.currency
                    : '-'
                }}
              </template>
            </b-table-column>

          </b-table>
        </div>
      </template>

      <!-- Пагинация и выбор количества элементов на странице -->
      <template slot="bottom-left">
        <div class="pagination-controls">
          <v-select
            style="width: fit-content; float: left;"
            v-model="params.perPage"
            @change="getLeadsuOffers"
            :items="perPageOptions"
            item-text="name"
            item-value="value"
            outlined
            hide-details
            dense
          />
        </div>
      </template>

    </b-table>

    <OverlayLoader :show="isLoading"/>

  </div>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";

export default {
  name: "LeadsuSearch",
  components: {
    OverlayLoader
  },
  data() {
    return {
      maxDetailWidth: 800,
      params: {
        // пагинация
        perPage: 20,
        page: 1,
        search: '',
      },
      perPageOptions: [
        { name: "10 на странице", value: 10 },
        { name: "20 на странице", value: 20 },
        { name: "50 на странице", value: 50 },
        { name: "100 на странице", value: 100 },
      ],
      openedOffersList: []
    };
  },
  mounted() {
    this.calculateMaxWidth();
    window.addEventListener('resize', this.calculateMaxWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateMaxWidth);
  },
  created() {
    this.getLeadsuOffers();
    this.getLeadsuAccounts();
  },
  computed: {
    leadsu_accounts() {
      return this.$store.getters.GET_LEADSU_ACCOUNTS;
    },
    leadsu_offer_goals() {
      return this.$store.getters.GET_LEADSU_OFFERS_GOALS;
    },
    leadsu_offers() {
      return this.$store.getters.GET_LEADSU_OFFERS;
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_LEADSU_OFFERS_LOADING;
      },
      set(value) {
        this.$store.commit("SET_LEADSU_OFFERS_LOADING", value);
      },
    },
  },
  methods: {
    calculateMaxWidth() {
      // Получаем ширину родительского контейнера
      const tableElement = this.$el.querySelector('.users-table');
      if (tableElement) {
        this.maxDetailWidth = tableElement.offsetWidth - 12 - 12 - 16 - 16 - 12; // отступы
        // 12 и 12 - это 0.75 rem по бокам
        // 16 - это 1rem по бокам
      }
    },
    onPageChange(page) {
      this.params.page = page;
      this.getLeadsuOffers();
    },
    getLeadsuOffers() {
      this.$store.dispatch("GET_LEADSU_OFFERS", this.params).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    getLeadsuAccounts() {
      this.$store.dispatch("GET_LEADSU_ACCOUNTS").catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    onClear() {
      this.params.search = '';
      this.getLeadsuOffers();
    },
    redirectToLeadsu(id) {
      const url = `https://webmaster.leads.su/offers/app/#/view/${id}`;
      window.open(url, '_blank');
    },
    goToLeadsuList() {
      this.$router.push('/offers-rates/leadsu-accounts');
    },
    getDataForOffer(id) {
      this.$store.dispatch("GET_LEADSU_OFFER_DATA_BY_ID", id)
        .then(() => {
          if (!this.openedOffersList.includes(id)) {
            this.openedOffersList.push(id)
          }
        })
        .catch(() => {
          this.$toast.error("Ошибка при получении данных");
        });
    },
    getOfferGoals(id) {
      return this.leadsu_offer_goals.find(i => i.id === id)
    }
  },
};
</script>
